import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import FirebaseConfig from "@/config/firebase";
import { Store } from 'vuex';

const app = firebase.initializeApp(FirebaseConfig);
// Get a Firestore instance
const db = firebase.firestore();
const auth = firebase.auth();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }

export function initDB(store: Store<any>) {
    auth.onAuthStateChanged((user: any) => {
        store.dispatch("updateUser", { user });
    });
}

export default db;
